// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"280520c5","408":"b75c75ad","638":"d34cc3a9"}[chunkId] + ".chunk.js";
};